module.exports = __webpack_public_path__ + "static/assets/c15700459e57153ea5c0c6929a9e57dd.png";